import React from 'react';

// TODO: this is a temporary workaround for eslint until bsa-ui is fixed
import { DatePicker } from 'bsa-ui';

import BasePicker, { basePropTypes } from './BasePicker';
import styles from './BasePicker.less';
import MonthPicker from './MonthPicker';
import RangePicker from './RangePicker';
import WeekPicker from './WeekPicker';

/**
 * @type {React.FC<import('./DatePicker.types').DatePickerProps>}
 */
const SblDatePicker = React.forwardRef(function SblDatePicker(props, ref) {
  return (
    <div className={styles.datePickerWrapper}>
      <BasePicker ref={ref} Picker={DatePicker} {...props} />
    </div>
  );
});

SblDatePicker.RangePicker = RangePicker;
SblDatePicker.MonthPicker = MonthPicker;
SblDatePicker.WeekPicker = WeekPicker;

SblDatePicker.propTypes = basePropTypes;

SblDatePicker.defaultProps = {
  format: 'MM/DD/YYYY',
};

export default SblDatePicker;
